<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> CONTAS A RECEBER POR FRANQUEADO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="error" v-if="errorAlert">
        <template v-slot:close>
          <v-icon @click="() => (errorAlert = false)"> mdi-close </v-icon>
        </template>
        Problema ao gerar o arquivo, tente novamente mais tarde
      </v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-row>
                <v-col cols="12" xs="12" md="4">
                  <label for="">Período de Faturamento:</label>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    label=""
                    v-mask="dateMask"
                    outlined
                    dense
                    required
                    :rules="[rules.required]"
                    v-model="billing_date_start"
                    append-outer-icon="mdi-calendar"
                    @click:append-outer="
                      handleClickCalendar('billing_date_start', null)
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    label=""
                    v-mask="dateMask"
                    outlined
                    dense
                    required
                    :rules="[rules.required]"
                    v-model="billing_date_end"
                    append-outer-icon="mdi-calendar"
                    @click:append-outer="
                      handleClickCalendar('billing_date_end', null)
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" md="4">
                  <label for="">Período de Vencimento:</label>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    label=""
                    v-mask="dateMask"
                    outlined
                    dense
                    required
                    :rules="[rules.required]"
                    v-model="due_date_start"
                    append-outer-icon="mdi-calendar"
                    @click:append-outer="
                      handleClickCalendar('due_date_start', null)
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-text-field
                    label=""
                    v-mask="dateMask"
                    outlined
                    dense
                    required
                    :rules="[rules.required]"
                    v-model="due_date_end"
                    append-outer-icon="mdi-calendar"
                    @click:append-outer="
                      handleClickCalendar('due_date_end', null)
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row>
                <v-col cols="12" xs="12" md="4">
                  <label for="">Tipo de Saída:</label>
                </v-col>
                <v-col cols="12" xs="12" md="4">
                  <v-select
                    :items="outputs"
                    v-model="output"
                    label=""
                    hide-details
                    dense
                    outlined
                  ></v-select>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="12" xs="12" md="2">
                  <v-btn
                    @click="handleMakeFile()"
                    :loading="loading"
                    dark
                    color="blue darken-3"
                    small
                    class="mt-1"
                  >
                    Gerar Arquivo
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
              <v-row v-if="download_link !== ''">
                <v-col>
                  <v-col class="d-flex justify-center">
                    <v-btn
                      dark
                      color="green darken-3"
                      class="mt-1"
                      large
                      target="_blank"
                      :href="download_link"
                    >
                      <v-icon left>mdi-cloud-download</v-icon>
                      Download Arquivo
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      ref="dialog"
      v-model="modalDate"
      :return-value.sync="dateDialog"
      width="290px"
    >
      <v-date-picker
        v-model="dateDialog"
        scrollable
        no-title
        @change="handlePickerDate"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Fechar </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import AwesomeMask from "awesome-mask";
export default {
  components: {},
  directives: {
    mask: AwesomeMask,
  },
  data: () => ({
    dateMask: "99/99/9999",
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    loading: false,
    errorAlert: false,
    lazy: false,
    valid: true,
    billing_date_start: "",
    billing_date_end: "",
    due_date_start: "",
    due_date_end: "",
    output: "A",
    outputs: [
      // {
      //   value: "R",
      //   text: "Relatório",
      // },
      {
        value: "A",
        text: "Arquivo",
      },
    ],
    modalDate: false,
    dateDialog: "",
    objDateDialog: {},
    fieldDateDialog: "",
    download_link: "",
    errorBillingDateEnd: "",
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {},
    validate() {},
    handleClickCalendar(field) {
      this.fieldDateDialog = field;
      this.dateDialog = this.dateToEua(this[field]);
      this.modalDate = true;
    },
    dateToEua(date) {
      if (date == undefined) return "";
      return date.split("/").reverse().join("-");
    },
    dateToBr(date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
    handlePickerDate() {
      this.modalDate = false;
      this[this.fieldDateDialog] = this.dateToBr(this.dateDialog);
    },
    async handleMakeFile() {
      this.loading = false;
      this.errorAlert = false;
      this.download_link = "";
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let myHeaders = new Headers({
            "Content-Type": "application/json",
          });
          let res = await fetch(`${URL}download/integration-create`, {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
              due_date_start: this.dateToEua(this.due_date_start),
              due_date_end: this.dateToEua(this.due_date_end),
              billing_date_start: this.dateToEua(this.billing_date_start),
              billing_date_end: this.dateToEua(this.billing_date_end),
            }),
          });
          if (res.ok) {
            res = await res.json();
            this.download_link = `${URL}download/integration-download/${res.nome}`;
          } else {
            throw new Error();
          }
        } catch (error) {
          this.errorAlert = true;
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
